import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { ATTENDANT_STYLES, GRID_CONFIG } from '../utils/patientFormConfig'
import { ArrayFormField } from './FormField'
import { usePatientFormI18n } from '../utils/patientFormI18n'

const LINKED_ACCOUNT_CHIP_STYLE = {
  fontSize: '11px',
  fontWeight: 600,
  lineHeight: 1,
  color: '#4338ca',
  background: 'rgba(67, 56, 202, 0.1)',
  borderRadius: '999px',
  padding: '4px 8px',
  marginTop: '8px',
  whiteSpace: 'nowrap',
  alignSelf: 'flex-start',
}

export const PatientAttendants = ({
  attendants = [],
  onAdd,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
  showContactFields = true,
}) => {
  const { copy, relationshipOptions } = usePatientFormI18n()

  const renderAttendant = (attendant, index, { onUpdate, onRemove, disabled }) => {
    const validation = validationHook?.getAttendantValidation(index)

    return (
      <div
        key={index}
        className="d-flex align-items-start gap-2 mb-2"
        style={{ width: '100%', flexWrap: 'wrap' }}
      >
        <div className="d-flex flex-column" style={{ flex: '1 1 220px', minWidth: 0 }}>
          <input
            style={ATTENDANT_STYLES.input}
            value={attendant?.name || ''}
            placeholder={copy.attendantNamePlaceholder}
            disabled={disabled}
            onChange={(e) => {
              if (!disabled) {
                onUpdate(index, 'name', e.target.value)
              }
            }}
          />
          {validation?.showError && (
            <small className="text-danger">{validation.errorMessage}</small>
          )}
        </div>

        <select
          value={attendant?.type}
          disabled={disabled}
          style={{ ...ATTENDANT_STYLES.select, minWidth: '110px' }}
          onChange={(e) => {
            if (!disabled) {
              onUpdate(index, 'type', e.target.value)
            }
          }}
        >
          {relationshipOptions.map((item, optionIndex) => (
            <option key={optionIndex} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>

        {showContactFields && (
          <input
            type="tel"
            inputMode="tel"
            style={{ ...ATTENDANT_STYLES.input, flex: '1 1 150px', minWidth: 0 }}
            value={attendant?.mobile || ''}
            placeholder={copy.attendantMobilePlaceholder}
            disabled={disabled}
            onChange={(e) => {
              if (!disabled) {
                onUpdate(index, 'mobile', e.target.value)
              }
            }}
          />
        )}

        {showContactFields && (
          <input
            type="email"
            inputMode="email"
            style={{ ...ATTENDANT_STYLES.input, flex: '1 1 170px', minWidth: 0 }}
            value={attendant?.email || ''}
            placeholder={copy.attendantEmailPlaceholder}
            disabled={disabled}
            onChange={(e) => {
              if (!disabled) {
                onUpdate(index, 'email', e.target.value)
              }
            }}
          />
        )}

        {attendant?.userId && (
          <span style={LINKED_ACCOUNT_CHIP_STYLE}>{copy.attendantLinkedAccountLabel}</span>
        )}

        <DeleteOutlineIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            marginTop: '10px',
          }}
          onClick={() => {
            if (!disabled) {
              onRemove(index)
            }
          }}
        />
      </div>
    )
  }

  return (
    <ArrayFormField
      label={copy.attendantsLabel}
      items={attendants}
      onAdd={editMode ? onAdd : undefined}
      onRemove={editMode ? onRemove : undefined}
      onUpdate={editMode ? onUpdate : undefined}
      renderItem={renderAttendant}
      disabled={!editMode}
      gridConfig={GRID_CONFIG}
      AddIcon={AddCircleOutlineIcon}
    />
  )
}

export default PatientAttendants
